import React from "react";
import { defaultLanguage } from "src/../src-dynamic/destination.languages";
import ErrorBoundary from "src/components/errorboundary/errorboundary.v1";
import FullImageModule from "src/modules/fullImage";

const SliceComponent = (props: any) => {
  const { sliceContext } = props;
  return <>
  <ErrorBoundary fallback={null}>
  <FullImageModule 
    defaultLanguage={defaultLanguage} 
    destinationId={sliceContext.destinationId}
    data={{ defaultLanguage: defaultLanguage, selectedLanguage: sliceContext.language, item: sliceContext.item }} 
  />
  </ErrorBoundary>
  </>
}

export default SliceComponent;